module.exports = __webpack_public_path__ + "img/lock-red.751856eb.svg";